export default {
  friendDetail: '/v3/recommend/friendDetail'
}
